import Vue from "vue"
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)

const USER_INFO_STORAGE_KEY = 'bzysPcUser'

function getStoredUserInfo() {
  const rawUserInfo = localStorage.getItem(USER_INFO_STORAGE_KEY)
  if (!rawUserInfo) {
    return {}
  }
  try {
    const parsedUserInfo = JSON.parse(rawUserInfo)
    return parsedUserInfo && typeof parsedUserInfo === 'object' ? parsedUserInfo : {}
  } catch (error) {
    localStorage.removeItem(USER_INFO_STORAGE_KEY)
    return {}
  }
}

export default new Vuex.Store({
  // 存储设置的变量
  state: {
    bgColor: "#F9F8F5",//底部的主题色
    loginFable: false,//登录弹框的显示/隐藏
    agrementIds: 0,//0 协议 1政策
    publicAgrementIds: 2,// 2平台优势 3关于我们
    agreementFlag: false,// 是否同意协议
    forgetpassFable: false,//忘记密码弹框的显示/隐藏
    registeredFable: false,//注册弹框
    navTopindex: 0,//头部索引
    keyword: "",//搜索字段
    mineIndex: -1,//默认不选中
    userInfo: getStoredUserInfo(),//用户信息
    antiPeekVisible: false,
    antiPeekContent: '课程版权所有，请勿截屏或录屏',
  },
  // 修改state里面的值
  mutations: {
    // 更新用户信息
    updateMe(state, userInfo) {
      const nextUserInfo = userInfo && typeof userInfo === 'object' ? userInfo : {};
      state.userInfo = nextUserInfo;
      if (Object.keys(nextUserInfo).length) {
        localStorage.setItem(USER_INFO_STORAGE_KEY, JSON.stringify(nextUserInfo));
      } else {
        localStorage.removeItem(USER_INFO_STORAGE_KEY);
      }
    },
    // 更新底部主题色
    updataColor(state, ploye) {
      state.bgColor = ploye
    },
    // 更新登录弹框
    updataLogin(state, ploye) {
      state.loginFable = ploye
    },
    // 更新访问用户协议 隐私政策
    updateAgemnt(state, ploye) {
      state.agrementIds = ploye
    },
    // 更新访问平台优势 关于我们
    updatePublicAgemnt(state, ploye) {
      state.publicAgrementIds = ploye
    },
    // 更新是否同意用户协议隐私政策
    updateAgreementFlag(state) {
      state.agreementFlag = !state.agreementFlag
    },
    // 更新忘记密码弹框
    updataForgetpass(state, ploye) {
      state.forgetpassFable = ploye
    },
    // 更新注册弹框
    updataRegistered(state, ploye) {
      state.registeredFable = ploye
    },
    upDatetopindex(state, ploye) {
      state.navTopindex = ploye
    },
    updataKeyword(state, ploye) {
      // 更新搜索框内容
      state.keyword = ploye
    },
    updataMineIndex(state, ploye) {
      // 更新我的资料
      state.mineIndex = ploye
    },
    showAntiPeek(state, content) {
      state.antiPeekVisible = true
      state.antiPeekContent = content || '课程版权所有，请勿截屏或录屏'
    },
    hideAntiPeek(state) {
      state.antiPeekVisible = false
    }
  },
  // 异步方法
  actions: {
  },
  plugins: [createPersistedState()]
})
